import { OrcaWhirlpoolClient } from "@orca-so/whirlpool-sdk";
import { Provider } from "@project-serum/anchor0.20.1";
import type { Wallet as AnchorWallet } from "@project-serum/anchor0.20.1/dist/cjs/provider";
import type { Connection } from "@solana/web3.js";

import { confirmOptions } from "../../constants/transaction";
import type { Wallet } from "../../types/wallet";
import { CONFIRM_OPTIONS } from "../../utils/network";
import type { NotificationContentStates } from "../../utils/transactions";
import { sendTransaction } from "../../utils/transactions";

export const claimWhirlpoolRewards = async ({
  connection,
  wallet,
  positionAddress,
  notificationContent,
}: {
  connection: Connection;
  wallet: Wallet;
  positionAddress: string;
  notificationContent: NotificationContentStates;
}) => {
  const whirlpoolClient = new OrcaWhirlpoolClient({ connection });
  const provider = new Provider(connection, wallet as AnchorWallet, CONFIRM_OPTIONS);
  const claimTransaction = await whirlpoolClient.position.getCollectFeesAndRewardsTx({
    positionAddress,
    provider,
  });
  const claimTx = await claimTransaction.build();
  return await sendTransaction(
    connection,
    wallet,
    claimTx.transaction.instructions,
    claimTx.signers,
    true,
    confirmOptions,
    true,
    notificationContent,
  );
};
